module.exports = __webpack_public_path__ + "img/no-setter.efabc3e4.svg";